import GameHot from "@/components/game/h-hot";
import gameItem from "@/components/game/game-item";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import zanwu from "@/assets/new/zanwu.png";
import {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
} from "@/lobby_common/utils/auth.js";
import { gameSearch } from "@/lobby_common/api/game_gen.js";
import { mapGetters } from "vuex";
import { divideAccuracy } from "@/lobby_common/utils/utils.js";
import { formattedValue } from "@/lobby_common/utils/index.js";
export default {
  name: "searchDrawer",
  mixins: [hideGmae],
  components: {
    GameHot,
    gameItem,
  },
  props: {},
  data() {
    return {
      formattedValue,
      searchKey: "",
      drawer: false,
      historyList: [],
      timer: null,
      pcList: [],
      showResult: false,
      loading: false,
      zanwu: zanwu,
      mainBox: "",
      time: "",
      showDown: "",
      hasMore: false,
      intervalId: null,
      updateInterval: 5000,
      page: 1,
      loadingTime: null,
      lastSid: 0,
    };
  },
  watch: {
    searchKey: {
      deep: true,
      handler(newVal) {
        if (newVal.trim().length !== 0) {
          this.debounce(this.searchFun, 500);
        } else {
          this.showResult = false;
          this.pcList = [];
        }
      },
    },
    drawer: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.searchRef.focus();
          });
        }
      },
    },
    // nav-menu-wrap
  },
  computed: {
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    topNavigation() {
      const data =
        this.$store.getters.getIsMobile === true
          ? this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5 ||
            null
          : this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc ||
            null;
      return data;
    },
    // topNavigation() {
    //   return (
    //      this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc || {}
    //   );
    // },
    topNavigationRight() {
      return (
        this.topNavigation &&
        this.topNavigation?.style === 1 &&
        this.topNavigation?.menuPosition === 2
      );
    },
    topNavigationNone() {
      return (
        this.topNavigation &&
        this.topNavigation?.style === 1 &&
        this.topNavigation?.menuPosition === 0
      );
    },
    topNavigation2() {
      return this.topNavigation && this.topNavigation?.style === 2;
    },
    topNavigation4() {
      return this.topNavigation && this.topNavigation?.style === 4;
    },
    gameList() {
      return this.pcList.map((item, i) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
          eid: `101_23_0_${i}`,
        };
      });
    },
    lang() {
      return this.$store.getters.getLang;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.app_config.base_coin_accuracy
        ? this.$store.getters.getPacketConfig?.app_config.base_coin_accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    ...mapGetters(["menuIsShow"]),
  },
  async created() {
    this.$Bus.$on("changeSearchDrawer", (flag) => {
      this.changeShow(flag);
    });
    this.$Bus.$on("globalClickHandle", () => {
      this.onGlobalClickHandle();
    });
    const str = getLocalStorage("gameNameHistory") || "";
    const arr = str.split(",");
    this.historyList = arr.filter((i) => i);

    this.showDown = getLocalStorage("showDown") || "";

    window.addEventListener("resize", this.commonSySize);
  },
  mounted() {},
  methods: {
    commonSySize() {
      try {
        if (!this.drawer) return;
        const box = document.querySelector(".drawer-wrap");
        if (!this.isMobile) {
          // PC 菜单栏被挤压 导致宽度不足240px 处理
          if (!this.menuIsShow) {
            box.style = "";
          } else {
            const mainBox = document.querySelector(".nav-menu-wrap");
            const menuWidth = mainBox?.offsetWidth;
            box.style = `left: ${menuWidth}px; width: calc(100% - ${menuWidth}px);`;
          }
        } else {
          box.style = "";
        }
      } catch (error) {
        console.log(error);
      }
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
    async getGamelistFun(isMore) {
      console.log("getGamelistFun", this.searchKey);
      const { code, data } = await gameSearch({
        pageSize: 12,
        lastSid: this.lastSid,
        keyword: this.searchKey && this.searchKey.trim(),
      });
      if (code === 0) {
        const games = data?.list || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        if (isMore) {
          this.pcList = [...this.pcList, ...new Set([...games])];
        } else {
          this.pcList = [...new Set([...games])];
        }
        this.hasMore = data?.hasMore;

        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
      }
    },
    moreFun() {
      this.lastSid = this.pcList[this.pcList.length - 1].gameGroupSid;
      console.log(this.lastSid);
      this.getGamelistFun(true);
    },
    onGlobalClickHandle() {
      if (this.drawer) {
        const now = new Date().getTime();
        if (now - this.time < 200) return;
        this.drawer = false;
        this.searchKey = "";
      }
    },
    changeShow(flag) {
      if (flag === true || flag === false) {
        this.drawer = flag;
      } else {
        this.drawer = !this.drawer;
      }
      this.time = new Date().getTime();
      if (this.drawer) {
        this.commonSySize();
      } else {
        this.searchKey = "";
      }
    },
    delKey(key) {
      console.log(key);
      const index = this.historyList.indexOf(key);
      this.historyList.splice(index, 1);
      const str = this.historyList.join(",");
      setLocalStorage("gameNameHistory", str);
    },
    clearKeys() {
      // 清除搜索记录缓存
      this.historyList = [];
      removeLocalStorage("gameNameHistory");
    },
    setKey(key) {
      this.searchKey = key;
      this.loading = true;
    },
    addKey(key) {
      if (!key) return;
      const index = this.historyList.indexOf(key);
      if (index >= 0) {
        this.historyList.splice(index, 1);
      }
      this.historyList.unshift(key);
      const str = this.historyList.join(",");
      setLocalStorage("gameNameHistory", str);
    },
    // 防抖
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    async searchFun() {
      if (this.searchKey?.trim().length < 2) {
        this.showResult = false;
        this.loading = false;
        this.pcList = [];
        return;
      }
      this.$eventPost("click", {
        eid: `101_0_0_128`,
        time: Date.now(),
      });
      this.showResult = true;
      this.loading = true;
      this.pcList = [];
      this.lastSid = 0;
      this.loadingTime = new Date().getTime();
      console.log("api111", this.searchKey);
      try {
        await this.getGamelistFun();
        this.addKey(this.searchKey);
      } catch (error) {
        console.log(error);
      } finally {
        //
        const now = new Date().getTime();
        if (now - this.loadingTime <= 200) {
          const timer = setTimeout(() => {
            this.loading = false;
            clearTimeout(timer);
          }, 200);
        } else {
          this.loading = false;
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.commonSySize);
    this.$Bus.$off("changeSearchDrawer");
    this.$Bus.$off("globalClickHandle");
  },
};
